import { pick } from '@lib/i18n/path';
import { GetterTree, mapGetters } from 'vuex';
import { IState } from './state';
import { IStore } from '..'
import { format } from '@lib/i18n';
import { not, propEq, compose, pick as ramdaPick } from 'ramda';

const propNotZero = (p: string) => compose(not, propEq(p, 0));

type TranslateFunc = (k: string, values?: object) => string|undefined

export function mapTranslate(funcName: string = '$translate'): {$translate: TranslateFunc} {
    return mapGetters('i18n', {
        [funcName]: 'translate'
    }) as any
}

export default {
    translate(state: IState) {
        const pickCache: {[k: string]: any} = {};

        return (k: string, values?: object) => {
            let picked = null;
            if (pickCache.hasOwnProperty(k)) {
                picked = pickCache[k];
            } else {
                picked = pick(k, state.translations);
            }

            if (picked === null) {
                console.warn('i18n: translation path is invalid:', k);
                return '';
            }

            return format(picked, values);
        };
    },
    countriesPhoneDialCodes(state: IState) {
        return state.countries
            .filter(propNotZero('dialCode'))
            .map(ramdaPick(['name', 'dialCode']));
    }
} as GetterTree<IState, IStore>
